import type { DungeonShopConfig } from "@/dungeon/dungeon-shop-types";
import type { HomeEconomy } from "@/home/economy";

export const DUNGEON_MONSTER_POWER_CARD_CASH_COST = 10;
export const DUNGEON_MONSTER_POWER_CARD_SKU = "dungeon.monster_power_card.v1";

export function dungeonMonsterPowerCardCount(economy: HomeEconomy): number {
  return Math.max(0, Math.floor(economy.dungeonMonsterPowerCards ?? 0));
}

export function grantDungeonMonsterPowerCards(
  economy: HomeEconomy,
  count: number,
): HomeEconomy {
  const qty = Math.max(0, Math.floor(count));
  if (qty <= 0) return economy;
  return {
    ...economy,
    dungeonMonsterPowerCards: dungeonMonsterPowerCardCount(economy) + qty,
  };
}

type Ok<T> = { ok: true } & T;
type Fail = { ok: false; reason: string };

export function applyDungeonMonsterPowerCard(
  economy: HomeEconomy,
  shop: DungeonShopConfig,
  currentMultiplier: number,
): Ok<{ economy: HomeEconomy; powerMultiplier: number }> | Fail {
  if (dungeonMonsterPowerCardCount(economy) <= 0) {
    return { ok: false, reason: "ไม่มีบัตรคูณพลัง — ซื้อที่ร้าน Cash (10/ใบ)" };
  }
  const next = Math.floor(currentMultiplier) + 1;
  const max = Math.floor(shop.cashMaxPowerMultiplier);
  if (next > max) {
    return { ok: false, reason: `คูณพลังสูงสุด ×${max}` };
  }
  return {
    ok: true,
    economy: {
      ...economy,
      dungeonMonsterPowerCards: dungeonMonsterPowerCardCount(economy) - 1,
    },
    powerMultiplier: next,
  };
}

export function stepDungeonMonsterPowerDown(currentMultiplier: number): number {
  return Math.max(1, Math.floor(currentMultiplier) - 1);
}
